<template>
  <div class="main-container">
    <div class="image-container height386">
      <img src="@/assets/zxdt/zxdt.png" />
    </div>
    <div class="container">
      <NewsCell
        v-for="message in messagees"
        :key="message.PublishMessageID"
        :message="message"
      >
        {{ message }}</NewsCell
      >
    </div>
  </div>
</template>

<script>
import { getdynamiclist } from "@/request/api.js";
import NewsCell from "@/components/news/NewsCell";
export default {
  components: {
    NewsCell
  },
  created() {
    let that = this;
    getdynamiclist().then(res => {
      if (res.statusText == "OK") {
        console.log(res);
        that.messagees = res.data.UserList;
        console.log(that.message, "fdsfsafdfsafafd");
      }
    });
  },
  data() {
    return {
      messagees: [],
      imageDate: [
        {
          imagePath: require("@/assets/home/banner_index01.png"),
          bgColor: "#060a3c"
        },
        {
          imagePath: require("@/assets/home/02.png"),
          bgColor: "#f3be00"
        },
        {
          imagePath: require("@/assets/home/03.png"),
          bgColor: "#14514c"
        }
      ]
    };
  }
};
</script>
<style lang="less" scoped>
.main-container {
  min-height: 700px;
  .demo-carousel {
    height: 385px;
    width: 100%;
    display: flex;
    justify-content: space-around;
    img {
      margin: 0 auto;
    }
  }
  .height386 {
    height: 386px;
    display: flex;
    justify-content: space-around;
  }
  .image-container {
    background-color: #344f97;
    text-align: center;
  }
  .container {
    padding:64px 0;
    margin-top: 20px;
    width: 1200px;
    display: flex;
    flex-wrap: wrap;
    // justify-content: space-around;
    margin: 0 auto;
  }
}
</style>
